import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular/standalone';
import { User } from 'src/app/interfaces/user';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { OfflineService } from './services/offline.service';
import { SharedService } from './services/shared.service';

import { SplashScreen } from '@capacitor/splash-screen';
import { ApplicationService } from './services/application.service';
import { ShardHealthService } from './services/shard-health.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})

/**
 * App component
 * @class AppComponent
 */
export class AppComponent {
  public currentUser: User = null;
  versionNumber: string;
  private title = environment.CUSTOMIZATION.PROJECT_NAME;
  private icon = environment.CUSTOMIZATION.FAVICON;
  public showSideMenu = environment.CUSTOMIZATION.SHOWSIDEMENU;
  private favIcon: HTMLLinkElement = document.querySelector('#appFavicon');
  public showMenu: boolean = true;

  constructor(
    private applicationService: ApplicationService,
    private platform: Platform,
    private authService: AuthService,
    private titleService: Title,
    private offlineService: OfflineService,
    public route: ActivatedRoute,
    public router: Router,
    private sharedService: SharedService,
    // Injected only to construct it at app bootstrap so its authoritative shard-status polling
    // starts as soon as there is a session (rather than lazily on the first HTTP request).
    private shardHealthService: ShardHealthService,
  ) {
    this.initializeApp();
    this.setTitle(this.title);
    this.setFavicon(this.icon);
    this.authService.currentUser.subscribe((user) => {
      this.currentUser = user;
      if (user !== null) {
        this.offlineService.syncToLocalStorage();
      }
    });
    this.sharedService.observeData().subscribe((data) => {
      if (data && data.showMenu !== undefined) {
        this.showMenu = data.showMenu;
      }
    });
  }

  /**
   * Initialize app
   */
  initializeApp() {
    this.platform.ready().then(() => {
      SplashScreen.hide();
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener(
          'backbutton',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
          },
          false,
        );
      });
    });
  }

  /**
   * Set title
   * @param newTitle - new title
   */
  private setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  /**
   * Set favicon
   * @param newFavicon - new favicon
   */
  private setFavicon(newIcon) {
    if (this.favIcon !== null) {
      this.favIcon.href = newIcon;
    }
  }
}
